<div class="content-modal">
    <div class="modal-header">
        <h5 class="modal-title">Acta de ejecución de validación</h5>
        <button type="button" class="close" (click)="closeModal()">
                <span aria-hidden="true">&times;</span>
            </button>
    </div>

    <p class="modal-texto">La presente acta respalda la realización de la Reunión de Validación llevada a cabo por la Unidad educativa <strong>{{jardineSelected.jardin}} {{jardineSelected.rbd}}</strong> como parte de la octava aplicación del Modelo de Gestión de Calidad de
        la Educación Parvularia, sintetizando información relevante respecto a esta.</p>

    <h5 class="modal-texto"><strong>PARTICIPANTES</strong></h5>

    <form #datosForm="ngForm" id="form-datosForm" (ngSubmit)="enviarActaFirmada()">
        <div class="row datosBasicos">
            <div class="col-md-12">
                <div class="row">
                    <div class="col-md-4"><label for=""><strong>Nombre de la Directora/Encargada:</strong></label></div>
                    <div class="col-md-4"><input type="text" class="form-control" name="actaData.nombreDirectora" [(ngModel)]="actaData.nombreDirectora" placeholder="Nombre Directora" disabled /></div>
                </div>
            </div>
        </div>

        <div class="row datosBasicos">
            <div class="col-md-6">
                <div class="row">
                    <div class="col-md-3"><label for=""><strong>Validador 1</strong></label></div>
                    <div class="col-md-7"><input type="text" class="form-control" name="actaData.validador1" [(ngModel)]="actaData.validador1" placeholder="Nombre Validador 1" disabled /></div>
                </div>

            </div>
            <div class="col-md-6">
                <div class="row">
                    <div class="col-md-5"><label for="cedulaId1"><strong>Cédula de Identidad N°:</strong></label>
                    </div>
                    <div class="col-md-5"><input type="text" class="form-control" name="actaData.cedulaId1" [(ngModel)]="actaData.cedulaId1" placeholder="11.111.111-1" disabled /></div>
                </div>
            </div>
        </div>

        <div class="row datosBasicos">
            <div class="col-md-6">
                <div class="row">
                    <div class="col-md-3"><label for=""><strong>Validador 2</strong></label></div>
                    <div class="col-md-7"><input type="text" class="form-control" name="actaData.validador2" [(ngModel)]="actaData.validador2" placeholder="Nombre Validador 2" disabled /></div>
                </div>

            </div>
            <div class="col-md-6">
                <div class="row">
                    <div class="col-md-5"><label for=""><strong>Cédula de Identidad N°:</strong></label></div>
                    <div class="col-md-5"><input type="text" class="form-control" name="actaData.cedulaId2" [(ngModel)]="actaData.cedulaId2" placeholder="22.222.222-1" disabled /></div>
                </div>
            </div>
        </div>
        <br>
        <br>
        <h5 class="modal-texto"><strong>TIEMPOS:</strong></h5>
        <P class="modal-texto">Escriba la fecha, horario y duración de la Entrevista de validación.</P>

        <h5 class="modal-texto"><strong>Sesión 1</strong></h5>
        <div class="row datosBasicos">
            <div class="col-md-12">
                <div class="row">
                    <div class="col-md-1"><label for="">Fecha</label></div>
                    <div class="col-sm-2">
                        <div class="input-group">
                            <input class="form-control" placeholder="" style="padding: 6px 12px;" [disabled]="!buttonCrear" name="sesionFecha1" [(ngModel)]="actaData.fechaInicioReal1" ngbDatepicker #d1="ngbDatepicker">
                            <div class="input-group-append">
                                <button class="btn btn-outline-secondary calendar" [disabled]="!buttonCrear" (click)="d1.toggle()" style="width: 40px;padding: 6px 12px;" type="button">
                                <i class="fas fa-calendar-alt"></i>
                            </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-1"><label for="">Hora de Inicio</label></div>
                    <div class="col-md-2">
                        <ngb-timepicker name="horaInicio1" [(ngModel)]="horaInicio1" [disabled]="!buttonCrear"></ngb-timepicker>
                    </div>
                    <div class="col-md-1"><label for="">Hora de Término</label></div>
                    <div class="col-md-2">
                        <ngb-timepicker name="horaFin1" [(ngModel)]="horaFin1" [disabled]="!buttonCrear"></ngb-timepicker>
                    </div>
                    <div class="col-md-1"><label for="">Duración</label></div>
                    <div class="col-md-1"><input type="text" class="form-control" placeholder={{duracionGetSesion1()}} name="actaData.duracion1" placeholder="" disabled/></div>
                </div>
            </div>
        </div>

        <p class="modal-texto"><strong>Sesión 2</strong></p>
        <div class="row datosBasicos">
            <div class="col-md-12">
                <div class="row">
                    <div class="col-md-1"><label for="">Fecha</label></div>
                    <div class="col-sm-2">
                        <div class="input-group">
                            <input class="form-control" placeholder="" style="padding: 6px 12px;" [disabled]="!buttonCrear" name="sesionFecha2" [(ngModel)]="actaData.fechaInicioReal2" ngbDatepicker #d2="ngbDatepicker">
                            <div class="input-group-append">
                                <button class="btn btn-outline-secondary calendar" [disabled]="!buttonCrear" (click)="d2.toggle()" style="width: 40px;padding: 6px 12px;" type="button">
                                <i class="fas fa-calendar-alt"></i>
                            </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-1"><label for="">Hora de Inicio</label></div>
                    <div class="col-md-2">
                        <ngb-timepicker name="horaInicio2" [(ngModel)]="horaInicio2" [disabled]="!buttonCrear"></ngb-timepicker>
                    </div>
                    <div class="col-md-1"><label for="">Hora de Término</label></div>
                    <div class="col-md-2">
                        <ngb-timepicker name="horaFin2" [(ngModel)]="horaFin2" [disabled]="!buttonCrear"></ngb-timepicker>
                    </div>
                    <div class="col-md-1"><label for="">Duración</label></div>
                    <div class="col-md-1"><input type="text" class="form-control" name="actaData.duracion2" placeholder={{duracionGetSesion2()}} disabled/></div>
                </div>
            </div>
        </div>

        <h5 class="modal-texto"><strong>OBSERVACIONES:</strong></h5>

        <p class="modal-texto">Registre aquí las observaciones o comentarios que se consideren relevantes en cuanto al cumplimiento de la labor de validación, en acuerdo con la directora:</p>

        <div class="col-md-12">
            <textarea matInput class="form-control" name="actaData.observaciones" [disabled]="!buttonCrear" [(ngModel)]="actaData.observaciones" placeholder="Escriba aquí sus observaciones..."></textarea>
        </div>

        <p class="modal-texto">Se otorga el presente documento para constancia de la Directora o Encargada del Jardín Infantil y Dupla de validadores.</p>

        <div class="col-md-12">
            <div class="row buttonFooter">
                <div class="col-md-2"><button type="button" class="buttonVolver" (click)="closeModal()">Volver</button>
                </div>
                <div class="col-md-2" *ngIf="buttonEstado"><button type="submit" class="buttonFirmar" [disabled]="!actaData.fechaInicioReal1 || !actaData.fechaInicioReal2">Firmar</button></div>
            </div>
        </div>
    </form>
</div>